





































































































































































































































































































import Vue from "vue";
import BaseModalWindow from "@/app/shared/components/base/BaseModalWindow.vue";
import BaseSearchInput from "@/app/shared/components/base/BaseSearchInput.vue";
import { $eventsBus } from "@/main";

export default Vue.extend({
  name: "MusicLibraryWindow",
  components: { BaseModalWindow, BaseSearchInput },
  data: function () {
    return {
      files: [],
      filteredFiles: [],
      stockFiles: [],
      tab: "stock",
      playingFile: {
        currentTime: 0,
        file: null,
        isStockFile: false,
        isNowPlaying: false,
      },

      stockSearchValue: "",
      currentSearchPage: 1,
      limitSearchPage: 1,
      isStockWaitSearch: false,
    };
  },
  computed: {
    items: function () {
      return this.$store.state.items;
    },
    previewItem: function () {
      return this.$store.state.selectedItem;
    },
    userStockAccess: function () {
      return this.$store.state.userInfo.stockAccess;
    },
    isMainContentMuted: {
      // getter
      get: function () {
        return this.$store.state.muted;
      },
      // setter
      set: function (newValue) {
        this.$store.commit("muted", newValue);
      },
    },
  },

  created() {
    /*     $eventsBus.$on("showRenderItemPreview", (item) => {
      this.onOpen(item);
    }); */
  },
  mounted() {
    this.updateMusicFiles();
    $eventsBus.$emit("muteMainContent", true);
    if (!this.userStockAccess) {
      this.tab = "music";
    }
  },
  watch: {
    tab: function () {
      if (this.tab === "stock") {
        const musicsStock = this.$refs.musicsStock;
        if (musicsStock.onscroll) {
          return;
        }
        musicsStock.onscroll = (e) => {
          if (
            musicsStock.scrollTop + musicsStock.clientHeight >=
            musicsStock.scrollHeight
          ) {
            this.searchMore();
          }
        };
      }
    },
  },
  methods: {
    updateMusicFiles() {
      this.axios
        .post(
          "/audio/getMusic",
          {
            sessionId: this.$store.state.userInfo.sessionId,
          },
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          this.files = [];
          response.data.forEach((file) => {
            this.files.push({
              duration: file.duration,
              path: file.path,
              id: file.id,
              name: file.name,
            });
          });
          this.searchInLibrary();
        });
    },
    searchInLibrary() {
      if (this.stockSearchValue === "") {
        this.filteredFiles = this.files;
      } else {
        this.filteredFiles = this.files.filter(
          (f) => f.name.toLowerCase().indexOf(this.stockSearchValue) !== -1
        );
      }
    },
    search() {
      this.stockFiles = [];
      this.currentSearchPage = 1;
      this.limitSearchPage = 1;
      if (this.stockSearchValue === "") {
        this.isStockWaitSearch = false;
        this.searchInLibrary();
        return;
      }
      this.isStockWaitSearch = true;
      this.searchInLibrary();
      this.requestList();
    },
    searchMore() {
      console.log("try search more");
      if (
        this.stockSearchValue === "" ||
        this.currentSearchPage === this.limitSearchPage ||
        this.isStockWaitSearch
      ) {
        return;
      }
      this.isStockWaitSearch = true;
      this.requestList();
    },
    requestList() {
      if (!this.userStockAccess) {
        this.isStockWaitSearch = false;
        return;
      }
      this.axios
        .post(
          "/utils/storyblocksList",
          {
            tag: this.stockSearchValue,
            page: this.currentSearchPage,
            mode: "music",
            sessionId: this.$store.state.userInfo.sessionId,
          },
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          if (this.stockSearchValue !== JSON.parse(response.config.data).tag) {
            return;
          }
          this.limitSearchPage = response.data.limit;
          this.currentSearchPage =
            this.currentSearchPage === this.limitSearchPage
              ? this.limitSearchPage
              : this.currentSearchPage + 1;
          response.data.list.forEach((file) => {
            this.stockFiles.push(file);
          });
          this.isStockWaitSearch = false;
        });
    },
    changeCheckedItems() {
      if (!this.previewItem.currentVariation.checked) {
        return;
      }
      this.items.forEach((item) => {
        item.variations.forEach((v) => {
          if (!v.checked || v === this.previewItem.currentVariation) {
            return;
          }
          v.music.file = this.previewItem.currentVariation.music.file;
          v.music.stockFile = this.previewItem.currentVariation.music.stockFile;
          v.checkAndUpdateMusicTime();
        });
      });
    },
    clearPlayingFile() {
      this.playPauseAudio(false, true);
      this.playingFile.file = null;
    },
    closeWindow() {
      $eventsBus.$emit("muteMainContent", false);
      this.$emit("close");
    },
    audioTimeChanged(e) {
      this.playingFile.currentTime = e.target.currentTime;
    },
    playPrevNextFile(isPrev) {
      let files = this.playingFile.isStockFile
        ? this.stockFiles
        : this.filteredFiles;
      let type = this.playingFile.isStockFile ? "stockFile" : "music";

      let currentIndex = files.indexOf(this.playingFile.file);
      if (currentIndex === -1 || (currentIndex !== -1 && files.length === 1)) {
        return;
      }
      let newIndex = isPrev
        ? currentIndex === 0
          ? files.length - 1
          : currentIndex - 1
        : currentIndex === files.length - 1
        ? 0
        : currentIndex + 1;
      this.playFile(type, files[newIndex]);
    },
    playFile(type?, file?) {
      if (!file || file === this.playingFile.file) {
        if (this.playingFile.file) {
          this.playPauseAudio(!this.playingFile.isNowPlaying, false);
        }
        return;
      } else {
        if (this.playingFile.file) {
          this.playPauseAudio(false, true);
        }
        this.playingFile.file = file;
        this.playingFile.isStockFile = type === "stockFile";
        this.playPauseAudio(true, false);
      }
    },
    getAudioElement(refName, reload = true) {
      /*
      this.$refs.musicPlayer.replaceChild(
        this.$refs[refName][0].children[0].cloneNode(true),
        this.$refs.musicPlayer.lastChild
	  ); */
      if (reload) {
        this.$refs.musicPlayer.load();
      }
      return this.$refs.musicPlayer;
      //return this.$refs[refName] ? this.$refs[refName][0] : null;
    },
    playPauseAudio(isPlay, isResetTime) {
      let audio = this.getAudioElement(
        (this.playingFile.isStockFile ? "musicStock" : "music") +
          this.playingFile.file.id
      );
      if (audio) {
        if (isResetTime) {
          audio.currentTime = 0;
        }
        isPlay ? audio.play() : audio.pause();
        this.playingFile.isNowPlaying = isPlay;
      }
    },
    onAddNewFile() {
      (<HTMLElement>this.$refs.fileInput).click();
    },
    onSelectTrack(type, file) {
      if (type === "stockFile") {
        this.previewItem.currentVariation.music.file = null;
        this.previewItem.currentVariation.music.stockFile = file;
      } else if (type === "file") {
        this.previewItem.currentVariation.music.file = file;
        this.previewItem.currentVariation.music.stockFile = null;
      }
      if (this.isMainContentMuted) {
        this.isMainContentMuted = false;
      }
      this.changeCheckedItems();
      this.closeWindow();
    },
    isMusicSelected(file) {
      return (
        this.previewItem?.currentVariation.music.file === file ||
        this.previewItem.currentVariation.music.stockFile === file
      );
    },
    onLikeMusic(file) {
      const config = {
        headers: {
          Accept: "*/*",
          "Content-Type": "application/json",
        },
      };

      let route = "/utils/getStoryblocks";
      this.axios
        .post(
          route,
          { item: file, sessionId: this.$store.state.userInfo.sessionId },
          config
        )
        .then((res) => {
          this.updateMusicFiles();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onDeleteMusic(file) {
      let isDelete = window.confirm("Are you sure to delete music?");
      if (!isDelete) {
        return;
      }
      const config = {
        headers: {
          Accept: "*/*",
          "Content-Type": "application/json",
        },
      };

      let route = "/audio/remMusic";
      this.axios
        .post(
          route,
          { id: file.id, sessionId: this.$store.state.userInfo.sessionId },
          config
        )
        .then((res) => {
          if (this.playingFile.file == file) {
            this.clearPlayingFile();
          }
          if (this.isMusicSelected(file)) {
            //this.clearMusic();
          }
          let indexToDelete = this.files.indexOf(file);
          this.files.splice(indexToDelete, 1);
          this.searchInLibrary();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onFileChanged(event: any) {
      let files: FileList = event.target.files;
      this.validateAndUploadFiles(files);
      event.target.value = "";
    },
    validateAndUploadFiles(files) {
      let result: File[] = [];
      const maxCount = 10;
      let maxIndex = files.length > maxCount ? maxCount : files.length;
      for (var i = 0; i < maxIndex; i++) {
        result.push(<File>files.item(i));
      }
      this.uploadFiles(result);
    },
    uploadFiles(files: File[]) {
      const config = {
        headers: {
          Accept: "*/*",
          "Content-Type": "application/json",
        },
      };

      let data = new FormData();
      for (var i = 0; i < files.length; i++) {
        let file = files[i];
        data.append("files[" + i + "]", file);
      }
      data.append("sessionId", this.$store.state.userInfo.sessionId);

      let route = "/uploads/uploadMediaFiles";

      this.axios
        .post(route, data, config)
        .then((res) => {
          res.data.forEach((file) => {
            this.files.unshift({
              duration: file.duration,
              path: file.file,
              id: file.fileId,
              name: file.name,
            });
            this.searchInLibrary();
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    clickOnProgressBar(event) {
      let fullWidth = event.target.getBoundingClientRect().width;
      let clickWidth = event.offsetX;
      let progress = clickWidth / fullWidth;

      let audio = this.getAudioElement(
        (this.playingFile.isStockFile ? "musicStock" : "music") +
          this.playingFile.file.id,
        false
      );
      if (audio) {
        audio.currentTime = this.playingFile.file.duration * progress;
      }
    },
    formatSecondToMSS(s) {
      return (s - (s %= 60)) / 60 + (9 < s ? ":" : ":0") + s;
    },
  },
});
